export interface GoogleSheetsData {
  timestamp: string;
  nom: string;
  email: string;
  telephone: string;
  date_evenement: string;
  produits: string;
  chateau_type: string;
  message: string;
  source: string;
}

export const sendToGoogleSheets = async (data: GoogleSheetsData): Promise<boolean> => {
  // URL de votre Google Apps Script (la bonne URL)
  const googleAppsScriptURL = "https://script.google.com/macros/s/AKfycbyyQ4xz3yEhx5PbljEmJZU3eGS2_u58wf7-rRyoz0dO6i0XNb0g0LgaTKkcUVdse3j1mA/exec";
  
  try {
    console.log("📊 DÉBUT: Envoi vers Google Sheets");
    console.log("📊 URL:", googleAppsScriptURL);
    console.log("📊 Données:", data);
    
    const response = await fetch(googleAppsScriptURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      mode: "no-cors", // Nécessaire pour éviter les erreurs CORS avec Google Apps Script
      body: JSON.stringify(data),
    });
    
    console.log("📊 Réponse Google Sheets - Status:", response.status);
    console.log("📊 Réponse Google Sheets - Type:", response.type);
    console.log("✅ SUCCÈS: Données envoyées vers Google Sheets");
    
    return true;
    
  } catch (sheetsError) {
    console.error("❌ ERREUR: Google Sheets échoué:", sheetsError);
    // Ne pas throw l'erreur car ce n'est qu'un backup
    return false;
  }
};

export const formatProductsForSheets = (products: { sumo?: boolean; chateau?: boolean }, chateauType?: string, getChateauDisplayName?: (id: string) => string) => {
  const produits = [];
  
  if (products.sumo) {
    produits.push("🤼 Sumo Gonflable (50€)");
  }
  
  if (products.chateau) {
    const chateauName = chateauType && getChateauDisplayName 
      ? getChateauDisplayName(chateauType) 
      : chateauType || "Château Gonflable";
    produits.push(`🏰 ${chateauName}`);
  }
  
  return produits.join(', ');
};